// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2O4t7","Label":"BuildControl_Label__1ObNU","Less":"BuildControl_Less__2rcpP","More":"BuildControl_More__2H1Ae"};